import { z } from 'zod/v4';

import { type BidAmountRange, parseBidSizeRanges } from './bid-size';

// The Bid Size filter on the wire: explicit OR'd amount windows. Arrives as the
// compact `min-max` comma string (GET query) or a JSON array (POST body); either
// way it's coerced to `BidAmountRange[]`. Shared by every endpoint that filters
// by bid amount so the format stays identical across tabs.
export const bidSizeRangesSchema = z.preprocess((val) => {
  const ranges = parseBidSizeRanges(val as string | BidAmountRange[] | null);
  // Empty / absent → undefined so the parsed value matches the `.optional()`
  // type: "no selection" reads the same as "param not sent" downstream.
  return ranges.length > 0 ? ranges : undefined;
}, z
  .array(z.object({ min: z.number(), max: z.number().nullable() }))
  .optional());
